
export default {
  data() {
    return {
      termsConditionsInfo: '',
    }
  },
  async created() {
    await this.getInfoList()
  },
  methods: {
    getInfoList() {
      this.$axios.get('/uk-api/others/clause').then(res => {
        if (res.code == 1) {
          this.termsConditionsInfo = res.result.content
        }
      })
    },
  },
}
